<template>
  <div class="delete-incomplete-archives-dialog-box">
    <el-dialog
      :title="$t('wr-dashboard.delete-all-incomplete-archives-dialog-box.title')"
      @close="onClose"
      visible
    >
      <div class="el-text el-text--body-24 mx-24 my-16">
        {{ $t('wr-dashboard.delete-archive.message') }}
      </div>

      <template slot="footer">
        <el-button
          @click="onClose"
          native-type="button"
          type="secondary"
        >
          {{ $t('wr-dashboard.form.button.cancel') }}
        </el-button>
        <el-button
          native-type="button"
          @click="onDelete"
          type="danger"
          :loading="isInProgress"
          :disabled="isInProgress"
        >
          {{ $t('wr-dashboard.form.button.delete') }}
        </el-button>
      </template>
    </el-dialog>
  </div>
</template>

<script>
import { createNamespacedHelpers } from 'vuex';

import {
  PENDING_STATUS,
  COMPLETED_STATUS
} from '../store/action-status';

import {
  DELETE_ALL_INCOMPLETE_BACKUPS
} from '../store/action-types';

const { mapGetters, mapActions } = createNamespacedHelpers('wr-dashboard');

export default {
  name: 'DeleteIncompleteArchivesDialogBox',
  data() {
    return {
    };
  },
  computed: {
    ...mapGetters([
      'getDeleteAllIncompleteStatus',
      'getTotalUsedSpace',
      'getIncompleteBackupsSize'
    ]),
    isInProgress() {
      return this.getDeleteAllIncompleteStatus === PENDING_STATUS;
    }
  },
  watch: {
    getDeleteAllIncompleteStatus(status) {
      if (status === COMPLETED_STATUS) {
        this.onClose();
      }
    }
  },
  methods: {
    ...mapActions({
      deleteAllIncomplete: DELETE_ALL_INCOMPLETE_BACKUPS
    }),
    onDelete() {
      this.deleteAllIncomplete({
        totalUsedSpace: this.getTotalUsedSpace,
        incompleteBackupsSize: this.getIncompleteBackupsSize
      });
    },
    onClose() {
      this.$emit('handleClose');
    }
  }
};
</script>

<style lang="scss" scoped>

</style>
